import { Field } from "formik";
import { EMPTY_STRING } from "../../../constants";

const CustomSelect = ({ name, value, options, disabled, handleChange }) => {
  return (
    <Field
      as="select"
      className="form-control"
      name={name}
      value={value}
      disabled={disabled}
      onChange={handleChange}
    >
      <option key={name} value={EMPTY_STRING} disabled>
        Select an option
      </option>
      {options ? (
        options.map((option) => {
          const refName =
            option instanceof Object
              ? option.refName || option.key || option.name
              : option;
          const displayName = option instanceof Object ? option.name : option;
          return (
            <option key={refName} value={refName}>
              {displayName}
            </option>
          );
        })
      ) : (
        <option key={name}>Content not found</option>
      )}
    </Field>
  );
};
export default CustomSelect;
